/* Sticky mobile add-to-cart bar: slides in when the main Add to cart
 * leaves the viewport. Shows the selected variant title + price,
 * submits the same product form (no quantity maths). Respects
 * prefers-reduced-motion. Vanilla JS, no external requests.
 */
(function () {
  function init() {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    if (!bars.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    bars.forEach(function (bar) {
      var formId = bar.querySelector('button[form]');
      formId = formId ? formId.getAttribute('form') : null;
      var form = formId ? document.getElementById(formId) : bar.closest('form');
      var mainBtn = form ? form.querySelector('.product-form__submit') : null;
      if (!mainBtn) {
        bar.hidden = false;
        return;
      }

      function syncVariant() {
        var title = bar.querySelector('[data-sticky-variant]');
        var price = bar.querySelector('[data-sticky-price]');
        if (!title && !price) return;
        var root = bar.closest('product-info') || document;
        var script = root.querySelector('[data-selected-variant]');
        if (!script) return;
        try {
          var v = JSON.parse(script.textContent);
          if (v && v.title && title) title.textContent = v.title;
        } catch (e) {}
      }

      if ('IntersectionObserver' in window && !reduceMotion) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                bar.setAttribute('hidden', '');
              } else if (entry.boundingClientRect.top < 0) {
                syncVariant();
                bar.removeAttribute('hidden');
              } else {
                bar.setAttribute('hidden', '');
              }
            });
          },
          { threshold: 0 }
        );
        io.observe(mainBtn);
      } else {
        bar.hidden = false;
      }

      if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
        window.subscribe(window.PUB_SUB_EVENTS.variantChange, syncVariant);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
